import { SearchResultItem } from '@xiag-search/sdk';

export function getWeatherSourceUrl(item: SearchResultItem): string | null {
    const weatherSrc = item.customFields['weather-src'];
    if (typeof weatherSrc === 'string' && weatherSrc.trim().length > 0) {
        return new URL(weatherSrc.trim()).pathname;
    }
    if (item.url.match(/\/en\/weather-engadin\//)) {
        return new URL(item.url).pathname;
    }
    if (item.url.match(/\/de\/wetter-engadin\//)) {
        return new URL(item.url).pathname;
    }

    return null;
}
